import axios from "@/api/axiosInstance";
import type { SubscriptionAgreementResponse } from "./types";

export const getSubscriptionAgreement = async (
  caraSku: string,
): Promise<SubscriptionAgreementResponse> => {
  const response = await axios.get<SubscriptionAgreementResponse>(
    "/api/private/subscription-agreement",
    { params: { caraSku } },
  );
  return response.data;
};
